import React, { useEffect, useState } from "react";
import {
  formatDate,
} from "../../CommonMethhods/CommonMethods";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm, useFieldArray } from "react-hook-form";
import RoundLoader from "../../Components/Common/RoundRingLoader";

function PartnerPayoutBrokerage(props) {
  const dataBrokerage = props.rmsData || [];

  const PayOutSchema = Yup.object().shape({
    ApPayout: Yup.array().of(
      Yup.object().shape({
        partnerCode: Yup.string().required(),
        apId: Yup.string().required(),
        apCode: Yup.string().required(),
        apName: Yup.string().required(),
        apModule: Yup.string().required(),
        partnerModule: Yup.string().required(),
        sapCode: Yup.string().required(),
        periodFrom: Yup.string().required(),
        periodTo: Yup.string().required(),
        pan: Yup.string().required(),
        gstNo: Yup.string().required(),
        actualGrossBrokerage: Yup.string().required(),
        grossBrokerage: Yup.string().required(),
        apSharing: Yup.string().required(),
        partnerSharing: Yup.string().required(),
        netBrokerage: Yup.string().required(),
        gst18Perc: Yup.string().required(),
        totalInvoice: Yup.string().required(),
        tds5Perc: Yup.string().required(),
        apLedger: Yup.string().required(),
        apRisk: Yup.string().required(),
        airtelCharges: Yup.string().required(),
        depositToBeAdjusted: Yup.string().required(),
        depositAmt: Yup.string().required(),
        apAMC: Yup.string().required(),
        otherDeductionFR: Yup.string().required(),
        otherDeductionFin: Yup.string().required(),
        finalPayout: Yup.string().required(),
        nseRegistered: Yup.string().required(),
        bseRegistered: Yup.string().required(),
        partnerStatus: Yup.string().required(),
        rmsStatus: Yup.string(),
        financeStatus: Yup.string(),
        bankingStatus: Yup.string(),
        partnerRemarks: Yup.string(),
      })
    ),
  });

  const optionsDf = { resolver: yupResolver(PayOutSchema) };
  const { control, register, reset, getValues, formState } = useForm(optionsDf);
  const { fields: payoutField } = useFieldArray({ name: "ApPayout", control });

  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedAll, setSelectedAll] = useState(false);

  useEffect(() => {
    reset({ ApPayout: dataBrokerage });
    setSelectedRows([]);
    setSelectedAll(false);
  }, [dataBrokerage]);

  const isSelectable = (i) => {
    const ps = getValues(`ApPayout.${i}.partnerStatus`);
    const rs = getValues(`ApPayout.${i}.rmsStatus`);
    const fs = getValues(`ApPayout.${i}.financeStatus`);
    const bs = getValues(`ApPayout.${i}.bankingStatus`);
    return (
      ps !== "Approved" ||
      rs === "Rejected" ||
      fs === "Rejected" ||
      bs === "Rejected"
    );
  };

  const formatToYYYYMMDD = (dateStr) => {
    if (!dateStr) return "";
    const [month, day, year] = dateStr.split(" ")[0].split("/");
    return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
  };

  const onApprove = (status) => {
    const SubmitArray = selectedRows.map((index) => {
      const payout = getValues(`ApPayout[${index}]`);
      return {
        partnerCode: payout.partnerCode || 0,
        apCode: payout.apCode || "",
        apName: payout.apName || "",
        periodFrom: formatToYYYYMMDD(payout.periodFrom) || "",
        periodTo: formatToYYYYMMDD(payout.periodTo) || "",
        actualGrossBrokerage: payout.actualGrossBrokerage || 0,
        grossBrokerage: payout.grossBrokerage || 0,
        netBrokerage: payout.netBrokerage || 0,
        gsT18Perc: payout.gst18Perc || 0,
        totalInvoice: payout.totalInvoice || 0,
        tdS5Perc: payout.tds5Perc || 0,
        apLedger: payout.apLedger || 0,
        apRisk: payout.apRisk || 0,
        airtelCharges: payout.airtelCharges || 0,
        depositToBeAdjusted: payout.depositToBeAdjusted || 0,
        depositAmt: payout.depositAmt || 0,
        apAMC: payout.apAMC || 0,
        otherDeductionFR: payout.otherDeductionFR || 0,
        otherDeductionFin: payout.otherDeductionFin || 0,
        finalPayout: payout.finalPayout || 0,
        partnerStatus: status || "",
        partnerRemarks: payout.partnerRemarks || "",
      };
    });
    return SubmitArray;
  };

  const onFormState = () => formState.isValid;

  const handleDownload = (typeFile, apCode) => {
    props.downloadOnClick(typeFile, apCode);
  };

  const handleDownloadRaw = () => {
    props.getPartnerRawData();
  };

  props.getFormData.onApprove = onApprove;
  props.getFormData.onFormState = onFormState;

  const selectAllChange = (e) => {
    const checked = e.target.checked;
    setSelectedAll(checked);
    const selectableIndices = payoutField
      .map((_, i) => i)
      .filter((i) => isSelectable(i));
    setSelectedRows(checked ? selectableIndices : []);
  };

  const singleInputChange = (e) => {
    const index = Number(e.target.value);
    const { checked } = e.target;
    setSelectedRows((prev) => {
      const updated = checked
        ? [...prev, index]
        : prev.filter((v) => v !== index);
      setSelectedAll(
        payoutField
          .map((_, i) => i)
          .filter((i) => isSelectable(i))
          .every((i) => updated.includes(i))
      );
      return updated;
    });
  };

  const allApproved = dataBrokerage.every(
    (item) => item.partnerStatus === "Approved"
  );

  const isApproved = (i) => getValues(`ApPayout.${i}.partnerStatus`) === "Approved";


  return (
    <>
      {/* <div className="tableHead">
        <button className="downloadBtnPayout1" onClick={() => getPartnerRawData()}>
          Raw Download
        </button>
        <button
          className="downloadBtnPayout"
          onClick={() => handleDownload("excel", "")}
        >
          {props.downloadLoader ? (
            <div className="download-loader">
              <RoundLoader h={"10"} />
            </div>
          ) : (
            "Download"
          )}
        </button>
      </div> */}

      <div className="tableHead">
        <button
          className="downloadBtnPayout1"
          onClick={() => handleDownloadRaw()}
          disabled={props.rawDownloadLoader} // disable during loading
        >
          {props.rawDownloadLoader ? (
            <div className="download-loader">
              <RoundLoader h={"10"} />
            </div>
          ) : (
            "Raw Download"
          )}
        </button>

        <button
          className="downloadBtnPayout"
          onClick={() => handleDownload("excel", "")}
          disabled={props.downloadLoader} // disable during loading
        >
          {props.downloadLoader ? (
            <div className="download-loader">
              <RoundLoader h={"10"} />
            </div>
          ) : (
            "Download"
          )}
        </button>
      </div>


      <div className="ap_master_table scroll-table payout-brokerage-wrapper">
        <table className="table ">
          <thead>
            <tr>
              <th colSpan={35}>Brokerage</th>
            </tr>
            <tr>
              <th>
                <input
                  type="checkbox"
                  id="select-all-payout"
                  // checked={selectedAll}
                  checked={
                    selectedAll ||
                    (dataBrokerage.length > 0 &&
                      dataBrokerage.every(
                        (_, i) =>
                          selectedRows.includes(i) ||
                          getValues(`ApPayout.${i}.partnerStatus`) === "Approved"
                      ))
                  }
                  onChange={selectAllChange}
                  disabled={allApproved}
                />
              </th>
              <th>Partner Code</th>
              <th>AP Code</th>
              <th>AP Name</th>
              <th>SAP Code</th>
              <th>Pan No</th>
              <th>Period From</th>
              <th>Period To</th>
              <th>AP Module</th>
              <th>Partner Module</th>
              <th>GST No</th>
              <th>Actual Gross Brokerage</th>
              <th>Gross Brokerage</th>
              <th>AP Sharing %</th>
              <th>Partner Sharing %</th>
              <th>Net Brokerage</th>
              <th>GST 18%</th>
              <th>Total Invoice</th>
              <th>TDS 5%</th>
              <th>AP Ledger</th>
              <th>AP Risk</th>
              <th>Airtel Charges</th>
              <th>Deposit to be Adjusted</th>
              <th>Deposit Amount</th>
              <th>AP AMC</th>
              <th>Other Deductions FR</th>
              <th>Other Deductions Fin</th>
              <th>Final Payout</th>
              <th>NSE Registered</th>
              <th>BSE Registered</th>
            </tr>
          </thead>

          <tbody>
            {payoutField.map((item, i) => (
              <tr key={i}>
                <td>
                  <input
                    type="checkbox"
                    value={i}
                    onChange={singleInputChange}
                    // checked={selectedRows.includes(i)}
                    checked={selectedRows.includes(i) || isApproved(i)}
                    disabled={!isSelectable(i)}
                  />
                </td>
                <td>
                  <input
                    className="plane-input"
                    readOnly
                    {...register(`ApPayout.${i}.partnerCode`)}
                  />
                </td>
                <td>
                  <input
                    className="plane-input"
                    readOnly
                    {...register(`ApPayout.${i}.apCode`)}
                  />
                </td>
                <td>
                  <input
                    className="plane-input"
                    readOnly
                    {...register(`ApPayout.${i}.apName`)}
                  />
                </td>
                <td>
                  <input
                    className="plane-input"
                    readOnly
                    {...register(`ApPayout.${i}.sapCode`)}
                  />
                </td>
                <td>
                  <input
                    className="plane-input"
                    readOnly
                    {...register(`ApPayout.${i}.pan`)}
                  />
                </td>
                {/* Fixed Period From */}
                <td>
                  <input
                    className="plane-input"
                    readOnly
                    value={
                      getValues(`ApPayout.${i}.periodFrom`)
                        ? formatDate(
                            getValues(`ApPayout.${i}.periodFrom`).split(" ")[0]
                          )
                        : ""
                    }
                  />
                </td>
                {/* Fixed Period To */}
                <td>
                  <input
                    className="plane-input"
                    readOnly
                    value={
                      getValues(`ApPayout.${i}.periodTo`)
                        ? formatDate(
                            getValues(`ApPayout.${i}.periodTo`).split(" ")[0]
                          )
                        : ""
                    }
                  />
                </td>

                {[
                  "apModule",
                  "partnerModule",
                  "gstNo",
                  "actualGrossBrokerage",
                  "grossBrokerage",
                  "apSharing",
                  "partnerSharing",
                  "netBrokerage",
                  "gst18Perc",
                  "totalInvoice",
                  "tds5Perc",
                  "apLedger",
                  "apRisk",
                  "airtelCharges",
                  "depositToBeAdjusted",
                  "depositAmt",
                  "apAMC",
                  "otherDeductionFR",
                  "otherDeductionFin",
                  "finalPayout",
                  "nseRegistered",
                  "bseRegistered",
                ].map((key) => (
                  <td key={key}>
                    <input
                      className="plane-input"
                      readOnly={
                        ![
                          "airtelCharges",
                          "depositToBeAdjusted",
                          "apAMC",
                          "otherDeductionFR",
                        ].includes(key)
                          ? true
                          : !isSelectable(i)
                      }
                      type={
                        ["airtelCharges", "depositToBeAdjusted", "apAMC", "otherDeductionFR"].includes(
                          key
                        )
                          ? "number"
                          : "text"
                      }
                      defaultValue={getValues(`ApPayout.${i}.${key}`)}
                      {...register(`ApPayout.${i}.${key}`)}
                    />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <h4>Total No Of Records : {dataBrokerage.length}</h4>
    </>
  );
}

export default PartnerPayoutBrokerage;
